import React, { Component } from 'react';
import {
  Route,
  Switch,
  Redirect
} from 'react-router-dom';
import { connect } from 'react-redux';
import store from '../../store';
import jwt_decode from 'jwt-decode';
import setAuthToken from '../../utils/setAuthToken';
import { setCurrentUser, logoutUser } from '../../actions/authActions';
import { clearCurrentProfile } from '../../actions/profileAction';
import PrivateRoute from '../../components/common/PrivateRoute';
import Login from '../../components/auth/Login';

import Header from '../../components/Header/Header';
import Footer from '../../components/Footer/Footer';
import Sidebar from '../../components/Sidebar/Sidebar';

import adminRoutes from '../../routes/admin.jsx';
import internRoutes from '../../routes/intern.jsx';
import welcomePage from '../../components/intern/welcomePage';
import excelTestSolutionUpload from '../../components/intern/excelTestSolutionUpload';
import introEngTest from '../../components/intern/introEngTest';
import introPersonalityTest from '../../components/intern/introPersonalityTest';
import introIntTest from '../../components/intern/introIntTest';
import introIntTestOne from '../../components/intern/introIntTestOne';
import engTest from '../../components/intern/engTest';
import intTestOne from '../../components/intern/intTestOne';
import introIntTestTwo from '../../components/intern/introIntTestTwo';
import intTestTwo from '../../components/intern/intTestTwo';
import introIntTestThree from '../../components/intern/introIntTestThree';
import intTestThree from '../../components/intern/intTestThree';
import personalityTest from '../../components/intern/personalityTest';
import adminPanel from '../../components/internAdmin/adminPanel';
import adminGraph from '../../components/internAdmin/adminGraph';
import admissionApplication from '../../components/internAdmin/admissionApplication';
import internData from '../../components/internAdmin/internData';

//Check for token
if (localStorage.jwtToken) {
  // Set auth token header auth
  setAuthToken(localStorage.jwtToken);
  // Decode token and get user info and exp
  const decoded = jwt_decode(localStorage.jwtToken);
  // Set user and isAuthenticated
  store.dispatch(setCurrentUser(decoded));

  // Check for expired token
  const currentTime = Date.now() / 1000;
  if (decoded.exp < currentTime) {
    // Logout user
    store.dispatch(logoutUser());
    // Clear current Profile
    store.dispatch(clearCurrentProfile());
    // Redirect to login
    window.location.href = '/login';
  }
}

class Dashboard extends Component {
  constructor(props) {
    super(props);
    this.componentDidMount = this.componentDidMount.bind(this);
    this.handleNotificationClick = this.handleNotificationClick.bind(this);
    this.state = {
      _notificationSystem: null
    };
  }
  handleNotificationClick(position) {
    this.state._notificationSystem.addNotification({
      title: <span data-notify="icon" className="pe-7s-gift" />,
      message: (
        <div>
          Welcome to <b>Light Bootstrap Dashboard</b> - a beautiful freebie for
          every web developer.
        </div>
      ),
      //level: level,
      position: position,
      autoDismiss: 15
    });
  }
  componentDidMount() {
  }
  componentDidUpdate(e) {
    if (
      window.innerWidth < 993 &&
      e.history.location.pathname !== e.location.pathname &&
      document.documentElement.className.indexOf('nav-open') !== -1
    ) {
      document.documentElement.classList.toggle('nav-open');
    }
    if (e.history.action === 'PUSH') {
      document.documentElement.scrollTop = 0;
      document.scrollingElement.scrollTop = 0;
      this.refs.mainPanel.scrollTop = 0;
    }
  }
  render() {
    let route;
    if (this.props.auth.isAuthenticated) {
      if (this.props.auth.user.position === 'Admin') {
        route = adminRoutes;
      } else if (this.props.auth.user.position === 'Intern') {
        route = internRoutes;
      } else {
        console.log('error')
      }
    } else {
      route = [
        { redirect: true, path: '/', to: '/login', name: 'Login' }
      ];
    }
    return (
      <div className="wrapper">
        <Sidebar {...this.props} />
        <div id="main-panel" className="main-panel" ref="mainPanel">
          <Header {...this.props} />
          <Route exact path="/login" component={Login} />
          <Switch>
            {route.map((prop, key) => {
              if (prop.name === 'Notifications')
                return (
                  <Route
                    path={prop.path}
                    key={key}
                    render={routeProps => (
                      <prop.component
                        {...routeProps}
                        handleClick={this.handleNotificationClick}
                      />
                    )}
                  />
                );
              if (prop.redirect)
                return <Redirect from={prop.path} to={prop.to} key={key} />;
              return (
                <Route path={prop.path} component={prop.component} key={key} />
              );
            })}
          </Switch>
          <Switch>
            <PrivateRoute exact path='/admissionApplication' component={admissionApplication} />
          </Switch>
          <Switch>
            <PrivateRoute exact path='/adminPanel/adminGraph/internData/:_id' component={internData} />
          </Switch>
          <Switch>
            <PrivateRoute exact path='/adminPanel/adminGraph/:_id' component={adminGraph} />
          </Switch>
          <Switch>
            <PrivateRoute exact path='/adminPanel' component={adminPanel} />
          </Switch>
          <Switch>
            <PrivateRoute exact path='/personalityTest' component={personalityTest} />
          </Switch>
          <Switch>
            <PrivateRoute exact path='/IntTestThree' component={intTestThree} />
          </Switch>
          <Switch>
            <PrivateRoute exact path='/introIntTestThree' component={introIntTestThree} />
          </Switch>
          <Switch>
            <PrivateRoute exact path='/intTestTwo' component={intTestTwo} />
          </Switch>
          <Switch>
            <PrivateRoute exact path='/introIntTestTwo' component={introIntTestTwo} />
          </Switch>
          <Switch>
            <PrivateRoute exact path='/intTestOne' component={intTestOne} />
          </Switch>
          <Switch>
            <PrivateRoute exact path='/engTest' component={engTest} />
          </Switch>
          <Switch>
            <PrivateRoute exact path='/introIntTestOne' component={introIntTestOne} />
          </Switch>
          <Switch>
            <PrivateRoute exact path='/introIntTest' component={introIntTest} />
          </Switch>
          <Switch>
            <PrivateRoute exact path='/introPersonalityTest' component={introPersonalityTest} />
          </Switch>
          <Switch>
            <PrivateRoute exact path='/introEngTest' component={introEngTest} />
          </Switch>
          <Switch>
            <PrivateRoute exact path='/welcomePage' component={welcomePage} />
          </Switch>
          <Switch>
            <PrivateRoute exact path='/excelTestSolutionUpload' component={excelTestSolutionUpload} />
          </Switch>
          <Footer />
        </div>
      </div>
    );
  }
}
const mapStateToProps = state => ({
  auth: state.auth
});
export default connect(mapStateToProps)(Dashboard);
